export default __webpack_public_path__ + "static/media/avataaars(1).3d490cac.png";